<template>
  <div>
    <v-flex class="ml-0 mb-1">
      <b>Total Expense:</b>
      {{formatMoney(expenseSummary)}} EUR -
      <b>Total Income:</b>
      {{formatMoney(incomeSummary)}} EUR
    </v-flex>

    <v-data-table
      :headers="headers"
      :items="artwork.artwork_costs ? artwork.artwork_costs.filter(c => c.category == '' || c.category == null) : []"
      hide-actions
      class="elevation-1 mx-0"
    >
      <template slot="items" slot-scope="props">
        <tr class="py-0 my-0">
          <td colspan="5">
            <v-container grid-list-xs text-xs-start xs12>
                <v-layout row wrap xs12>
                    <v-flex xs10>
                        <span class="subheadline pl-2"><b>{{ props.item.what_for }}</b></span>
                    </v-flex>
                    <v-flex xs2 py-0 my-0 text-xs-right>
                      <v-btn flat small icon ma-0>
                        <v-icon small @click="edit_cost(props.item)">edit</v-icon>
                      </v-btn>
                      <v-btn flat small icon ma-0 v-if="c_user.delete_rights">
                        <v-icon small @click="deleteItem(props.item)">delete</v-icon>
                      </v-btn>
                    </v-flex>
                  <v-flex xs2> </v-flex>
                  <v-flex xs3> 
                    <span class="subheadline pl-3">
                      {{ props.item.transaction_date ? props.item.transaction_date : 'no date set' }}
                    </span>
                  </v-flex>
                  <v-flex xs3> 
                    <span class="subheadline pl-3">
                      {{ props.item.income ? formatMoney(props.item.income) : ' - ' }} {{ props.item.income ? 'EUR' : ''}}
                    </span>
                  </v-flex>
                  <v-flex xs3> 
                    <span class="subheadline pl-3">
                      {{ props.item.expense ? formatMoney(props.item.expense) : ' - ' }} {{ props.item.expense ? 'EUR' : '' }}
                    </span>
                  </v-flex>
                  <v-flex xs1> </v-flex>

                </v-layout>
              </v-container>
          </td>
        </tr>
      </template>
    </v-data-table>

    <!-- <v-dialog v-model="dialog2" max-width="400px" px-0> -->
    <v-btn
      small
      color="primary"
      @click="showDialog=true"
      class="mx-3 mt-3 mb-0 right"
      v-if="c_user.edit && !showDialog"
    >
      <v-icon small class="mr-2">add</v-icon>Add Cost
    </v-btn>
    <v-card
      v-if="showDialog"
      class="mb-3 mx-3 pt-0 mt-3 elevation-2"
      style="background-color:#fff;"
    >
      <v-card-title class="px-3 pb-0 mb-0 pt-1">
        <span class="headline pt-2 pb-0 mb-0 pl-2" v-html="!editing ? 'New Cost' : 'Editing Cost'"></span>
      </v-card-title>
      <v-card-text class="mx-0 px-0 my-2 py-0">
        <v-container grid-list-xs pb-0 pt-0>
          <v-layout wrap>
            <v-flex xs12 ml-0 mb-1>
              <!-- <div class="subheading mb-2">Transaction Date</div> -->
              <v-date-picker
                v-model="artwork_cost.transaction_date"
                class="mb-3 elevation-0"
                color="black"
                full-width
                name="transaction_date"
                label="Transaction Date"
              ></v-date-picker>
            </v-flex>
            <v-flex xs12 mb-2>
              <v-text-field
                v-model="artwork_cost.what_for"
                class="flex pl-2"
                name="what_for"
                label="What for"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 mb-0>
              <v-text-field
                type="number"
                v-model="artwork_cost.income"
                class="flex pl-2"
                suffix=" EUR"
                name="income"
                label="Income"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 mb-0>
              <v-text-field
                v-model="artwork_cost.expense"
                type="number"
                class="flex pl-2"
                suffix=" EUR"
                name="expense"
                label="Expense"
              ></v-text-field>
            </v-flex>
            <!-- <v-flex xs12>
                <v-textarea rows=1 v-model="artwork_cost.content" class="flex xs12 ml-2" auto-grow name="content" label="Content"></v-textarea>
            </v-flex>-->
            <!-- <v-flex xs12>
                <v-textarea rows=1 v-model="artwork_cost.note" class="flex xs12 ml-2" auto-grow name="note" label="Note"></v-textarea>
            </v-flex>-->
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions class="pr-4 pb-4">
        <v-spacer></v-spacer>
        <v-btn small class="mr-3" outline @click.native="showDialog=false">Cancel</v-btn>
        <v-btn small dark @click.native="save">
          <span v-if="!editing">Add </span>
          <span v-if="editing">Save </span> cost
        </v-btn>
      </v-card-actions>
    </v-card>
    <!-- </v-dialog> -->
    <!-- <v-list class="xs12" three-line>

      <template v-for="ap in artwork.artwork_artwork_costs">
        <v-list-tile :key="ap.id+ 'artwork_cost'">
          <v-list-tile-content>
            <v-list-tile-title> {{ap.colli}} / {{ap.artwork_cost}}
              <span v-if="ap.artwork_location_id" class='text--primary'>Loc: {{get_location_name(ap)}} </span>
              <span v-if="ap.height">HE: {{ap.height}} cm</span>
              <span v-if="ap.width">WI: {{ap.width}} cm</span>
              <span v-if="ap.weight">WE: {{ap.weight}} kg</span>
              <span v-if="ap.visa_status">VS: {{get_visa_status(ap)}} </span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider :key="'a'+ap.id"></v-divider>
      </template>
    </v-list>-->

    <!-- <v-container class="my-0 mx-0 px-0 py-0" fluid >
      <v-layout class="my-0 mx-0 px-0 py-0 " row wrap>
          <v-card class="my-2 mx-2" height="300px" width="200px" v-for="p in artwork.artwork_artwork_costs" :key="p.id">
            <v-card-title><span class="headline" v-text="p.colli"></span></v-card-title>
            <v-card-text>
              ArtworkCost: {{p.artwork_cost}}<br />
              Location: {{get_location_name(p)}}<br />
              Height: {{p.height}} cm<br />
              Width: {{p.width}} cm<br />
              Weight: {{p.weight}} kg<br />
              Visa status: {{get_visa_status(p)}}<br />
            </v-card-text>
          </v-card>
      </v-layout>
      <v-btn icon class="mt-0 mb-0 xs12"  @click="showUpload=!showUpload"><v-icon>add</v-icon></v-btn>
      <v-flex v-if="showUpload" elevation-2>
        <v-container grid-list-xs fluid>
          <v-layout row wrap>
            <v-text-field v-model="artwork_cost.colli"   class="flex xs12 ml-2" name="colli" label="Colli"></v-text-field>
            <v-text-field v-model="artwork_cost.artwork_cost" class="flex xs12 ml-2" name="artwork_cost" label="ArtworkCost"></v-text-field>
            <v-text-field v-model="artwork_cost.height"  class="flex xs6 lg12 pl-2" suffix=" cm" name="height"  label="Height"></v-text-field>
            <v-text-field v-model="artwork_cost.width"   class="flex xs6 lg12 pl-2" suffix=" cm" name="width"   label="Width"></v-text-field>
            <v-textarea   v-model="artwork_cost.note"    class="flex xs12 ml-2" auto-grow name="note"    label="Note"></v-textarea>
            <v-flex xs12>
              <v-radio-group v-model="artwork_cost.visa_status">
                <v-radio v-for="vs in this.constants.VISA_STATUSES" :key="vs.id" :value="vs.id" :label="vs.name"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-autocomplete
              v-model="artwork_cost.artwork_location_id"
              :items="this.selection_items"
              label="Location"
              item-text="name"
              item-value="id"
              class="xs12 ml-2" 
              >
            </v-autocomplete>
          </v-layout>
        </v-container>
        <v-flex class="pl-3 pb-3">
          <v-btn @click="save">save</v-btn>
          <v-btn @click="showUpload=!showUpload">cancel</v-btn>
        </v-flex>
      </v-flex>
    </v-container>-->
  </div>
</template>

<script>
// import CommonMixin from '@/mixins/CommonMixin'
import { serverBus } from '../../main'
import axios from 'axios'
function dynamicSort (property) {
  var sortOrder = 1
  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }
  return function (a, b) {
    var result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0
    return result * sortOrder
  }
}
export default {
  // mixins: [ CommonMixin ],
  props: ['artwork'],
  data: () => ({
    showDialog: false,
    editing: false,
    selected: [],
    dialog: false,
    dialog2: false,
    headers: [
      // {
      //   text: 'Colli',
      //   align: 'left',
      //   sortable: true,
      //   value: 'colli'
      // },
      { text: 'What for', value: 'what_for', sortable: true },
      // { text: 'Created by', value: 'created_by', sortable: true },
      { text: 'Date', value: 'transaction_date', sortable: true },
      { text: 'Income', value: 'income', sortable: true },
      { text: 'Expense', value: 'expense', sortable: true },
      // { text: 'Content', value: 'content', sortable: true },
      // { text: 'Note', value: 'note', sortable: true },
      { text: false, sortable: false }
    ],
    editedIndex: -1,
    show: false,
    showUpload: false,
    artwork_cost: {
      what_for: '',
      transaction_date: '',
      income: '',
      expense: '',
      content: '',
      // note: '',
      artwork_id: ''
    }
  }),
  computed: {
    // c_user() {
    //   return this.$store.state.user.profile;
    // },
    incomeSummary () {
      // console.log('income')
      // console.log(this.artwork.artwork_costs)
      // console.log(this.artwork.artwork_costs.length)
      if (this.artwork.artwork_costs && this.artwork.artwork_costs.length > 0) {
        var out = this.artwork.artwork_costs.filter(function (ac) {
          if (ac.income) {
            // console.log(ac.expense)
            return ac.income > 0
          } else {
            return 0
          }
        })
        // console.log(out)
        if (out && out.length > 0) {
          return out.map(o => o.income).reduce((a, c) => a + c)
        } else {
          return 0
        }
      }
      // .reduce((a,b) => a + b, 0)
    },
    expenseSummary () {
      // console.log('expense')
      // console.log(this.artwork.artwork_costs)
      // console.log(this.artwork.artwork_costs.length)
      if (this.artwork.artwork_costs && this.artwork.artwork_costs.length > 0) {
        var out = this.artwork.artwork_costs.filter(function (ac) {
          if (ac.expense) {
            // console.log(ac.expense)
            return ac.expense > 0
          } else {
            return 0
          }
        })
        // console.log(out.map(o=>o.expense).reduce((a,c)=>a+c))
        if (out && out.length > 0) {
          return out.map(o => o.expense).reduce((a, c) => a + c)
        } else {
          return 0
        }
      }
      // .reduce((a,b) => a + b, 0)
    },
    // visa_status () {
    //   this.constants.VISA_STATUSES.find(this.artwork.visa_status)
    // },
    all_artwork_costs () {
      return this.$store.state.artwork_costs
      // console.log(todos)
      // return todos
    },
    // selection_items () {
    //   var artworkLocations = Object.assign([], this.$store.getters.enabled_locations)
    //   return artworkLocations.sort(dynamicSort('name'))
    // }
  },
  methods: {
    edit_cost (c) {
      this.artwork_cost = {
        what_for: '',
        transaction_date: '',
        income: '',
        expense: '',
        content: '',
        artwork_id: ''
      }
      this.editing = true
      try {
        this.artwork_cost = Object.assign(
          {},
          this.artwork.artwork_costs.find(t => t.id == c.id)
        )
        this.artwork_cost.transaction_date = this.format_date(
          this.artwork_cost.transaction_date
            ? this.artwork_cost.transaction_date
            : Date.now
        )
        this.showDialog = true
      } catch (error) {
        // console.log(error.message)
      }
    },
    initialize () {},
    deleteItem (item) {
      confirm('Are you sure you want to delete this Cost?')
      this.deleteCost(item)
    },
    deleteCost (c) {
      serverBus.$emit('showSnackbar', 'Deleting Cost.', 'black')
      let url = `${this.$globals.apiserver}/artwork_costs/${c.id}.json`
      axios
        .delete(url, c)
        .then(response => {
          serverBus.$emit('showSnackbar', 'Cost Deleted.', 'green')
          this.errors = {}
          const index = this.artwork.artwork_costs.indexOf(c)
          if (index >= 0) this.artwork.artwork_costs.splice(index, 1)
          this.$store.dispatch('updateArtwork', this.artwork.id)
        })
        .catch(error => {
          serverBus.$emit('showSnackbar', 'There was an Error deleting Cost.', 'red')
          this.errors = error.response.data
        })
    },
    // get_visa_status (artworkCost) {
    //   var vss = this.constants.VISA_STATUSES.filter(
    //     vs => vs.id === artworkCost.visa_status
    //   )
    //   if (vss[0] != undefined) {
    //     // console.log(vss[0].id)
    //     return vss[0].id > 0 ? vss[0].name : ''
    //   } else {
    //     return ''
    //   }
    // },
    // getUser (userId) {
    //   var l = this.$store.state.users.find(u => u.id === userId)
    //   return l ? l : ''
    // },
    save () {
      serverBus.$emit('showSnackbar', 'Saving Cost.', 'black')
      this.artwork_cost.artwork_id = this.artwork.id
      this.artwork_cost.created_by = this.c_user.id
      // this.artwork_cost.id = this.findMinMax(this.all_artwork_costs)+1
      if (!this.artwork.artwork_costs) {
        this.artwork.artwork_costs = []
      }
      // this.artwork.artwork_artwork_costs.push(this.artwork_cost)
      if (!this.editing) {
        axios
          .post(`${this.$globals.apiserver}/artwork_costs.json`, {
            artwork_cost: this.artwork_cost
          })
          .then(response => {
            serverBus.$emit('showSnackbar', 'Cost Saved.', 'green')
            this.errors = {}
            this.artwork.artwork_costs.push(response.data)
            this.editing = false
            // this.$store.commit('ADD_COST', response.data)
          })
          .catch(error => {
            serverBus.$emit('showSnackbar', 'There was an Error saving Cost.', 'red')
            this.errors = error.response.data
          })
      } else {
        let url = `${this.$globals.apiserver}/artwork_costs/${this.artwork_cost.id}.json`
        axios
          .put(url, {
            artwork_cost: this.artwork_cost
          })
          .then(response => {
            serverBus.$emit('showSnackbar', 'Cost Saved.', 'green')
            this.errors = {}
            this.artwork.artwork_costs = [
              ...this.artwork.artwork_costs.map(item =>
                item.id !== response.data.id
                  ? item
                  : { ...item, ...response.data }
              )
            ]
            this.editing = false
            // this.$store.commit("SAVE_COST", response.data);
            // this.$store.commit('ADD_COST', response.data)
          })
          .catch(error => {
            serverBus.$emit('showSnackbar', 'There was an Error saving Cost.', 'red')
            this.errors = error.response.data
          })
      }
      // console.log(this.artwork_cost)
      // this.all_artwork_costs.push(this.artwork_cost)
      // this.showUpload=!this.showUpload
      this.showDialog = false
      this.artwork_cost = {
        what_for: '',
        transaction_date: '',
        artwork_id: '',
        income: '',
        expense: '',
        content: ''
      }
    }

    // NEPOUZIVANE
    // findMinMax(arr) {
    //   let max = arr[0].id;
    //   for (let i = 1, len = arr.length; i < len; i++) {
    //     let v = arr[i].id;
    //     max = v > max ? v : max;
    //   }
    //   return max;
    // }
  }
}
</script>

<style scoped>
td, th {
  padding: 0px 0px 0px 0px !important;
}
/* table.v-table thead tr {
  height: 16px;
} */
table.v-table tbody td, table.v-table tbody th {
    height: 16px;
}
.v-btn--icon {
  width:26px;
  height: 26px;
}
/* .v-btn {
  height: 25px;
  width: 25px;
} */
.card {
  min-width: 250px;
}
table.v-table thead td:not(:nth-child(1)), 
table.v-table tbody td:not(:nth-child(1)), 
table.v-table thead th:not(:nth-child(1)), 
table.v-table tbody th:not(:nth-child(1)), 
table.v-table thead td:first-child, 
table.v-table tbody td:first-child, 
table.v-table thead th:first-child, 
table.v-table tbody th:first-child {
    padding: 0px 0px 0px 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/artworks/Costs.vue